export default __webpack_public_path__ + "static/media/hotel.c798fb92.svg";